<template>
  <div id="gaodeMap"></div>
</template>

<script>
  import AMap from 'AMap'
  export default {
    data(){
      return{
        amap:{}
      }
    },
    mounted(){
      this.drawGaodeMap();
    },
    methods:{
      drawGaodeMap(){
        this.amap = new AMap.Map('gaodeMap', {
          resizeEnable: true,
          zoom:3,//级别
          lang: "en" //可选值：en，zh_en, zh_cn
          // center: [116.397428, 39.90923],//中心点坐标
          //viewMode:'3D'//使用3D视图
        });
        var scale = new AMap.Scale(),
          toolBar = new AMap.ToolBar(),
          overView = new AMap.OverView();
        this.amap.addControl(scale);
        this.amap.addControl(toolBar);
        this.amap.addControl(overView);
      }
    }
  }
</script>
<style>
  #gaodeMap{
    width:100%; height: 500px;
  }
</style>
